/*
 *    Controller to show a collaborator's profile in relation to
 *    a 'target account' in order to see and edit permissions on
 *    the 'target account.'
 *
 *    Triggered via:
 *        Radio.request(
 *          'show_collaborators_profile',
 *          {{ACCOUNT}},
 *          {{COLLABORATOR}}
 *        );
 *    Arguments:
 *        ACCOUNT: Object. Backbone Model extended v5API "Model", specifically instance of models/v5/account.js
 *        COLLABORATOR: Object. Backbone Model extended v5API "Model", specifically instance of models/v5/account.js
*/

import Radio from 'backbone.radio';
import CollaboratorsProfileView from '@/views/collaborators_profile';
var globalCh = Radio.channel('global');
var routerCh = Radio.channel('router');
var apiCh = Radio.channel('api');
let created_at;

function getGrantedRoles(target_account, grantee_account) {
    let granted_roles = [];
    target_account.grants().forEach(function (grant) {
        if (grant.rel.get('grantee') === grantee_account) {
            granted_roles.push(grant.rel.get('role'));
            created_at = grant.get('created_at');
        }
    }, this);
    return granted_roles;
}

function show_collaborators_profile(account, collaborator) {
    let role_collection = apiCh.request('account_role');
    var app_container = globalCh.request('app_layout');

    let granted_roles = getGrantedRoles(account, collaborator);

    // Only allow this collection to contain things the roles the target account can actually 
    // grant to the grantee
    // WEB-1883
    if (account.get('tier') === 'developer') {
        role_collection = role_collection.get_developer_tier_roles();
    } else if (account.get('tier') === 'evaluation') {
        role_collection = role_collection.get_evaluation_tier_roles();
    }
    var profile_view = new CollaboratorsProfileView({
        model: collaborator,
        account: account,
        available_roles: role_collection,
        granted_roles: granted_roles,
        created_at: created_at,
    });
    app_container.showChildView('container', profile_view);

    // Change the secondary nav
    // show left nav
    globalCh.request('show_account_secondary_nav', { 
        selected: 'collaborators'
    });
    // set route
    routerCh.request('set_location', 'collaborators_profile', account, collaborator);
    // set breadcrumb nav
    globalCh.request('set_selection', {
        type: 'app',
        id: 'collaborators'
    });
}

export default show_collaborators_profile;
